var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"input-wrapper"},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-text-field',_vm._g(_vm._b({staticClass:"input",attrs:{"solo":"","hide-details":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }